import styled from 'styled-components'
import { theme } from '../theme';

export const LayoutWrapper = styled.div`
    width: ${theme.containerL};
    margin:0 auto;
`